module.exports = __webpack_public_path__ + "h5/img/noOrder.2cbd3a5a.png";